// extracted by mini-css-extract-plugin
export default {"departmentSelectWrapper":"DashboardDepartment_departmentSelectWrapper__lwDUA"};